/*!
 * 
 * 
 * Date: 2023-10-12T17:08Z
 * Copyright (c) <2023> <GTS Teclecom Service Private Limited>
 * Author : Ravi Jangra
 */
 // @flow
import React, { useState, useLayoutEffect, useRef,useEffect ,useContext} from "react";
import { FixedSizeList, areEqual } from "react-window";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// import "./style.css";
// import getInitialData from "./get-initial-data";
import { reorderList } from "./recoder";
import ThemeControls from "../../Component/AllThemesControl";
import {InputLabel} from '@material-ui/core';
import { MasterContext } from '../../services/MasterContext'; 
import { FormContext } from '../../Component/Forms/FormContext';
import OutlinedInput from '@mui/material/OutlinedInput';
import Loading from '../../images/Table/Loading.gif';
import FormHelperText from '@mui/material/FormHelperText';
import { APIGET } from '../../services/APIServices';

function getStyle({ draggableStyle, virtualStyle, isDragging }) {
  // If you don't want any spacing between your items
  // then you could just return this.
  // I do a little bit of magic to have some nice visual space
  // between the row items
  const combined = {
    ...virtualStyle,
    ...draggableStyle
  };

  // Being lazy: this is defined in our css file
  const grid = 4;
  const grids = 8;

  // when dragging we want to use the draggable style for placement, otherwise use the virtual style
  const result = {
    ...combined,
    height: isDragging ? combined.height : '30px',
    left: isDragging ? combined.left : combined.left + grid,
    // top: isDragging ? combined.top : combined.top + grids,
    width: isDragging
      ? draggableStyle.width
      : `calc(${combined.width} - ${grid * 2}px)`,
    marginBottom: grid,
  };

  return result;
}



function Item({ onDragEnd,columnId, provided, item, style, isDragging, index }) {
  // //console.log(columnId)
  // item.disabled=true
  function onDragAdd(index){
    const resultAdd = {
      source: {
        droppableId: 'column-0', // Replace with actual source ID
        index: index,                // Replace with actual index
      },
      destination: {
        droppableId: 'column-1', // Replace with actual destination ID
        index: index,                    // Replace with actual index
      },
      type: 'DEFAULT', // Replace with the appropriate type
    };
    onDragEnd(resultAdd)
  }
  function onDragRemove(index){
    if (!item.disabled) {
    const result= {
      source: {
        droppableId: 'column-1', // Replace with actual source ID
        index: index,                // Replace with actual index
      },
      destination: {
        droppableId: 'column-0', // Replace with actual destination ID
        index: index,                    // Replace with actual index
      },
      type: 'DEFAULT', // Replace with the appropriate type
    };
    onDragEnd(result)
  }
  }
 
  return (
    <div
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      ref={provided.innerRef}
      style={getStyle({
        draggableStyle: provided.draggableProps.style,
        virtualStyle: style,
        isDragging,
      })}
      className={`item ${isDragging ? "is-dragging" : ""} ${item.disabled ? "disabled" : ""}`}
    >
      {item.text}
      {columnId==="column-0"?<span onClick={()=>onDragAdd(index)}>+</span>:<span onClick={()=>onDragRemove(index)}>-</span>}
    </div>
    
  );
}

// Recommended react-window performance optimisation: memoize the row render function
// Things are still pretty fast without this, but I am a sucker for making things faster
const Row = React.memo(function Row(props) {
  const { data, index, style } = props;
  // alert(index)
  const item = data.column.items[index];
  // We are rendering an extra item for the placeholder
  if (!item) {
    return null;
  }

  return (
    <Draggable draggableId={item.id} index={index} key={item.id}>

      {provided => <Item index={index} onDragEnd={data.onDragEnd} columnId={data.column.id} provided={provided} item={item} style={style} />}
    </Draggable>
  );
}, areEqual);

const ItemList = React.memo(function ItemList({ column, index, onDragEnd }) {
  // There is an issue I have noticed with react-window that when reordered
  // react-window sets the scroll back to 0 but does not update the UI
  // I should raise an issue for this.
  // As a work around I am resetting the scroll to 0
  // on any list that changes it's index
  const listRef = useRef();
  useLayoutEffect(() => {
    const list = listRef.current;
    if (list) {
      list.scrollTo(0);
    }
  }, [index]);

  return (
    <Droppable
      droppableId={column.id}
      mode="virtual"
      renderClone={(provided, snapshot, rubric) => (
        <Item
          columnId={column.id}
          provided={provided}
          isDragging={snapshot.isDragging}
          item={column.items[rubric.source.index]}
        />
      )}
    >
      {(provided, snapshot) => {
        // Add an extra item to our list to make space for a dragging item
        // Usually the DroppableProvided.placeholder does this, but that won't
        // work in a virtual list
        const itemCount = snapshot.isUsingPlaceholder
          ? column.items.length + 1
          : column.items.length;
          const RowData = {
            column: column,
            onDragEnd: onDragEnd // Assuming onDragEnd is a function you want to assign
          };
        return (
          <FixedSizeList
            height={350}
            itemCount={itemCount}
            itemSize={34}
            width={250}
            outerRef={provided.innerRef}
            itemData={RowData}
            className="task-list"
            ref={listRef}
          >
            {Row}
          </FixedSizeList>
        );
      }}
    </Droppable>
  );
});

const Column = React.memo(function Column({ column, index, onDragEnd }) {

  return (
    <Draggable draggableId={column.id} index={index}>
      {provided => (
        <div
          className="column"
          {...provided.draggableProps}
          ref={provided.innerRef}
        >
          {/* <h3 className="column-title" {...provided.dragHandleProps}>
            {column.title}
          </h3> */}
          <ItemList onDragEnd={onDragEnd} column={column} index={index} />
        </div>
      )}
    </Draggable>
  );
});

export default function DragDrop(props) {
const {useStyle} = ThemeControls;
const classes = useStyle();
const {id, field_type, field_disabled_Edit, field_id, field_label, field_placeholder,field_disabled, field_value,field_option_src, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,onChange,field_mandatory } = props;
const { field_option_src_critieria, field_option_value, field_option_label,field_option_src_intcritieria, field_option_check_local_storage, field_option_src_context } = props.field_option_src;
let {masterData} = React.useContext(MasterContext);
const { handleChange } = useContext(FormContext);
const [state, setState] = useState(null);
const [searchTerm, setSearchTerm] = useState("");
const [loading, setLoading] = useState(true);

 async function getInitialData(props) {
  const { field_value } = props;
  let valuesToSkip = [];
  let apiValueDis = [];
  let firstColumnItems = [];
  let secondColumnItems = [];
  let cachedApiResponse={}
  const { field_option_src_critieria, field_option_value, field_option_label, field_option_src_context, field_option_src_intcritieria, field_option_src_intcontext, field_option_intvalue } = props.field_option_src;

  try {
    if(props.field_option_check_local_storage==="true"&&(masterData[`${props.field_option_src_context}`]&&masterData[`${props.field_option_src_context}`][`${field_id}`]&&masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`])){
      
    }else{
      cachedApiResponse = await APIGET(field_option_src_context + '/' + field_option_src_critieria);

      if(masterData[`${props.field_option_src_context}`&&`${props.field_option_src_context}`]){
        if(masterData[`${props.field_option_src_context}`][`${field_id}`]){
          masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = cachedApiResponse;
        }
        else{
          masterData[`${props.field_option_src_context}`][`${field_id}`] = {}
          masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = cachedApiResponse;
        }
      }
      else{
        masterData[`${props.field_option_src_context}`]={}
        masterData[`${props.field_option_src_context}`][`${field_id}`] = {}
        masterData[`${props.field_option_src_context}`][`${field_id}`][`${props.field_option_src_critieria}`] = cachedApiResponse;
      }
    }

    if (field_option_src_intcritieria) {

        const Data = await APIGET(field_option_src_intcontext + '/' + field_option_src_intcritieria);
       const cachedIntApiResponse = Data.data || [];
       
      const dataList = cachedIntApiResponse.map((item) => item[field_option_intvalue]);
      if (dataList && dataList.length > 0) {
        apiValueDis = [...dataList];
        valuesToSkip = [...dataList];
      } else {
        apiValueDis = [];
        valuesToSkip = [];
      }
    }
  
    function margValue(items,valueData) {
      if (typeof valueData === 'string') {
       return items[valueData]

      } else if (Array.isArray(valueData)) {
        let value = "";
        for (const item of valueData) {
          if (item.column) {
            value += items[item.column];
          } else if (item.string) {
            value += item.string;
          }
        }
        return value
      } else {
        // It's neither a string nor an array.
         
      }
    } 
    if (cachedApiResponse.data) {
      const apiCol = cachedApiResponse.data.map((item, index) => (
        {
          id: `${index}`,
          value: margValue(item,field_option_value),
          text: margValue(item,field_option_label),
          disabled: false
        }));

        const sortedApiCol = apiCol.slice().sort((a, b) => {
          const textA = a.text.toLowerCase();
          const textB = b.text.toLowerCase();
          if (textA < textB) {
            return -1;
          }
          if (textA > textB) {
            return 1;
          }
          return 0;
        });
        

      if (field_value && field_value.length > 0) {
        field_value.map(item => {
          valuesToSkip.push(item.value)
        });
      }

      if (valuesToSkip.length > 0) {
        firstColumnItems = apiCol
          .filter(item => {
            const itemValue = parseInt(item.value);
            return !valuesToSkip.includes(itemValue);
          })
          .sort((a, b) => {
            const textA = a.text.toLowerCase();
            const textB = b.text.toLowerCase();
            if (textA < textB) return -1;
            if (textA > textB) return 1;
            return 0;
          });

        // secondColumnItems = apiCol
        //   .filter(item => {
        //     const itemValue = parseInt(item.value);
        //     return valuesToSkip.includes(itemValue);
        //   })
        //   .map(item => {
        //     if (apiValueDis.includes(item.value)) {
        //       item.disabled = true;
        //     }
        //     return item;
        //   })
        //   .sort((a, b) => (a.disabled === b.disabled ? 0 : a.disabled ? -1 : 1));

        secondColumnItems = apiCol
  .filter(item => {
    const itemValue = parseInt(item.value);
    return valuesToSkip.includes(itemValue);
  })
  .map(item => {
    if (apiValueDis.includes(item.value)) {
      item.disabled = true;
    }
    return item;
  })
  .sort((a, b) => {
    // Sort by disabled state first
    if (a.disabled !== b.disabled) {
      return a.disabled ? -1 : 1;
    }
    // If both items have the same disabled state, sort by text name
    const textA = a.text.toLowerCase();
    const textB = b.text.toLowerCase();
    if (textA < textB) return -1;
    if (textA > textB) return 1;
    return 0;
  });
      }else {
        // If valuesToSkip is empty, set both arrays to empty arrays
        // firstColumnItems = [];
        secondColumnItems = [];
      }

      const initial = {
        columns: {
          "column-0": {
            id: "column-0",
            title: "First column",
            items: valuesToSkip.length > 0 ? firstColumnItems : sortedApiCol,
          },
          "column-1": {
            id: "column-1",
            title: "Second column",
            items: secondColumnItems.length > 0 ? secondColumnItems : [],
          }
        },
        columnOrder: ["column-0", "column-1"]
      };
      return initial;
    } else {
      return null;
    }
  } catch (err) {
    console.error(err);
    return null;
  }
}

useEffect(() => {
  setLoading(true); // Set loading state to true when starting API call
  getInitialData(props,masterData)
    .then(initialData => {
      setState(initialData);
    })
    .catch(error => {
      console.error('Error:', error);
    })
    .finally(() => {
      setLoading(false); // Set loading state to false after API call completes
    });
}, [field_option_src.field_option_src_intcritieria]);


function handleSearchChange(event) {
  const newSearchTerm = event.target.value;
  setSearchTerm(newSearchTerm);
 if(state !== null){
  if(newSearchTerm){
    setState(prevState => {
      const updatedItems = prevState?.columns["column-0"].items.map(item => ({
        ...item,
        isVisible: item.text.toLowerCase().includes(newSearchTerm.toLowerCase())
      }));
  
      const orderedItems = updatedItems?.filter(item => item.isVisible).concat(updatedItems.filter(item => !item.isVisible));
      
      return {
        ...prevState,
        columns: {
          ...prevState?.columns,
          "column-0": {
            ...prevState?.columns["column-0"],
            items: orderedItems
          }
        }
      };
    });

  }else{
    setState(prevState => {
      const sortedItems = prevState?.columns["column-0"].items.slice().sort((a, b) => {
        const textA = a.text.toLowerCase();
        const textB = b.text.toLowerCase();
        if (textA < textB) {
          return -1;
        }
        if (textA > textB) {
          return 1;
        }
        return 0;
      });

      return {
        ...prevState,
        columns: {
          ...prevState?.columns,
          "column-0": {
            ...prevState?.columns["column-0"],
            items: sortedItems
          }
        }
      };
    });
  }
 }
}


  function onDragEnd(result) {
    // //console.log(result)
    if (!result.destination) {
      return;
    }

    if (result.type === "column") {
      // if the list is scrolled it looks like there is some strangeness going on
      // with react-window. It looks to be scrolling back to scroll: 0
      // I should log an issue with the project
      const columnOrder = reorderList(
        state.columnOrder,
        result.source.index,
        result.destination.index
      );
      setState({
        ...state,
        columnOrder
      });
      return;
    }

    // reordering in same list
    if (result.source.droppableId === result.destination.droppableId) {
      const column = state.columns[result.source.droppableId];
      const items = reorderList(
        column.items,
        result.source.index,
        result.destination.index
      );
      // updating column entry
      const newState = {
        ...state,
        columns: {
          ...state.columns,
          [column.id]: {
            ...column,
            items
          }
        }
      };
      setState(newState);
      
      return;
    }

    // moving between lists
    const sourceColumn = state.columns[result.source.droppableId];
    const destinationColumn = state.columns[result.destination.droppableId];
    const item = sourceColumn.items[result.source.index];

    // 1. remove item from source column
    const newSourceColumn = {
      ...sourceColumn,
      items: [...sourceColumn.items]
    };
    if (!item.disabled) {
    newSourceColumn.items.splice(result.source.index, 1);
    }
    // 2. insert into destination column
    const newDestinationColumn = {
      ...destinationColumn,
      items: [...destinationColumn.items]
    };

    // in line modification of items
    if (!item.disabled) {
    newDestinationColumn.items.splice(result.destination.index, 0, item);
    }
    let destinationValue;
    if (newDestinationColumn.id === 'column-1') {
      destinationValue = newDestinationColumn.items.map(item => ({
        value: item.value,
        disabled: item.disabled
      }));
    } else if (newSourceColumn.id === 'column-1') {
      destinationValue = newSourceColumn.items.map(item =>({
        value: item.value,
        disabled: item.disabled
      }));
    }
   const values = destinationValue.join(', ');

   handleChange(field_id,{},destinationValue)
    const newState = {
      ...state,
      columns: {
        ...state.columns,
        [newSourceColumn.id]: newSourceColumn,
        [newDestinationColumn.id]: newDestinationColumn
      }
    };
    console.log(newSourceColumn)
    console.log(newDestinationColumn)
    setState(newState);
  }

  return (
    <div className={classes.dragroot} >
    <div style={{display:"flex"}}>
      <InputLabel className={classes.label}>
        {field_label}
      </InputLabel>
        {
          field_mandatory==="yes"?<span 
            style={{
              fontSize: "18px",
              color: "#d71729",
              fontWeight: "400",
              lineHeight: "20px",
              transform: "translateY(-2px)"
              }}
            >
              *
            </span>
        :<></>
      }
    </div>
    <OutlinedInput className={classes.input}
      id='grad_search'
      type="text"
      placeholder="Search..."
      value={searchTerm}
      onChange={handleSearchChange}
      style={{ marginBottom: "10px" }}
    />
    <DragDropContext onDragEnd={onDragEnd}>
        <Droppable
          droppableId="all-droppables"
          direction="horizontal"
          type="column"
          id = {field_id}
        >
          {provided => (
            <div
              className="columns"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {loading ?
                <div className="loader_1">
                  <img src={Loading} alt="Loading..." />
                </div>:state?state?.columnOrder?.map((columnId, index) => (
                <Column
                  key={columnId}
                  column={state.columns[columnId]}
                  index={index}
                  onDragEnd={onDragEnd}
                  
                />
              )):<div className="loader_1">No data!</div>}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
    </DragDropContext>
    <FormHelperText>{field_helperText}</FormHelperText>
    </div>
  );
}

